import { syncWithCis as sync } from './cis';

export var syncWithCis = sync;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-cis-sync/dist/ejs/index.js
// module id = 525
// module chunks = 0